import { useMemo } from 'react';
import { MapCheckIn } from './GpxMap.types';
import { ActivityOverviewSupportDto } from '../../../../core/api/FitnessActivityClient';
import { useGpxMapStore } from './GpxMap.store';
import { getColorForId } from './GpxMap.utils';

interface UseGpxMapProps {
    data: ActivityOverviewSupportDto | null;
}

export const useGpxMap = ({ data }: UseGpxMapProps) => {
    const { parsedWorkouts } = useGpxMapStore({ data });

    const filteredCheckIns: MapCheckIn[] = useMemo(() => {
        return (data?.facilityVisits || []).flatMap((checkIn) => {
            const { location, facilityName } = checkIn;
            if (
                location == null ||
                location.longitude == null ||
                location.latitude == null
            )
                return [];

            return [
                {
                    id: `${checkIn.id}`,
                    type: checkIn.visitType,
                    location: [location.longitude, location.latitude] as [
                        number,
                        number
                    ],
                    name: facilityName || 'unknown',
                    color: getColorForId(`${checkIn.id}`)
                }
            ];
        });
    }, [data?.facilityVisits]);

    return {
        parsedWorkouts,
        filteredCheckIns
    };
};
